import './index.css'
import FlashcardsDeck, { type FlashcardsDeckConfig } from './FlashcardsDeck'
import { mountCrucialReact } from './crucialReactMount'
import { renderCrucialRoot } from './renderCrucialRoot'
import { type ThemeMode, withHostTheme } from './themeHandler'

const ThemedFlashcardsDeck = withHostTheme(
  ({ config, theme }: { config: FlashcardsDeckConfig; theme: ThemeMode }) => (
    <FlashcardsDeck config={config} theme={theme} />
  ),
)

mountCrucialReact<FlashcardsDeckConfig>('FlashcardsDeck', (root, config) => {
  if (!Array.isArray(config.cards) || config.cards.length === 0) return

  renderCrucialRoot(
    root,
    'FlashcardsDeck',
    <ThemedFlashcardsDeck config={config} />,
  )
})
